import { isMobile } from "../../helpers/others";
export function initMainMenu() {
    const menuTrigger = document.querySelector('.global-menu-trigger');
    const menuBox = menuTrigger?.nextElementSibling;
    if (!menuTrigger || !menuBox)
        return;
    const toggleMenu = (isOpen) => {
        menuTrigger.classList.toggle('open', isOpen);
        menuTrigger.setAttribute('aria-expanded', isOpen.toString());
        if (!isMobile() && menuTrigger.classList.contains('global-menu-trigger')) {
            document.querySelector('button.wcag-opened')?.classList.remove('wcag-opened');
        }
    };
    menuTrigger.addEventListener('click', () => {
        const isExpanded = menuTrigger.classList.contains('open');
        toggleMenu(!isExpanded);
    });
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && menuTrigger.classList.contains('open')) {
            toggleMenu(false);
            menuTrigger.focus();
        }
    });
    menuBox.addEventListener('focusout', (event) => {
        const relatedTarget = event.relatedTarget;
        if (relatedTarget && !menuBox.contains(relatedTarget)) {
            toggleMenu(false);
        }
    });
}
